import { BaseMutations } from '@/store/base-mutations';
import { Staffs, StaffsCertsFilters } from '@/modules/staffs/types';
import CertificatesListState from '@/modules/staffs/store/modules/staff-certificates-list/state';

export default class CertificatesListMutations extends BaseMutations<CertificatesListState> {
  SET_CERTS(certs: Staffs.StaffCerts[]) {
    this.state.certs = certs;
  }

  TOGGLE_LOADING_CERTS(toggle: boolean) {
    this.state.loading = toggle;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof StaffsCertsFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  SET_USERS(users: Staffs.StaffCertsUsers | []) {
    this.state.users = users;
  }

  SET_COURSES(courses: Staffs.StaffCertsUsersCourses | []) {
    this.state.courses = courses;
  }

  SET_CERT_VALIDITY(cert_validity: string[]) {
    this.state.cert_validity = cert_validity;
  }

  SET_COURSES_REQUESTS_NOT_AVAILABLE(value: boolean) {
    this.state.is_request_courses_not_available = value;
  }
}
